'use client';

import React from 'react';
import Link from 'next/link';
import { ArrowRight, Paperclip } from 'lucide-react';
import StatusBadge from '@/components/ui/StatusBadge';
import { fundRequests, formatTZS } from '@/lib/mockData';

export default function RecentRequestsTable() {
  const recent = fundRequests?.slice(0, 8);

  return (
    <div className="bg-card border border-border rounded-xl shadow-card">
      <div className="flex items-center justify-between px-5 py-4 border-b border-border">
        <div>
          <h2 className="text-sm font-600 text-foreground">Recent Fund Requests</h2>
          <p className="text-xs text-muted-foreground mt-0.5">Latest submissions across all statuses</p>
        </div>
        <Link
          href="/submitted-requests"
          className="inline-flex items-center gap-1 text-xs font-600 text-primary hover:text-primary/80 transition-colors"
        >
          View all <ArrowRight size={12} />
        </Link>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border bg-muted/40">
              <th className="text-left px-4 py-3 text-[11px] font-600 uppercase tracking-widest text-muted-foreground whitespace-nowrap">Request ID</th>
              <th className="text-left px-4 py-3 text-[11px] font-600 uppercase tracking-widest text-muted-foreground whitespace-nowrap">Requestor</th>
              <th className="text-left px-4 py-3 text-[11px] font-600 uppercase tracking-widest text-muted-foreground whitespace-nowrap">Project</th>
              <th className="text-left px-4 py-3 text-[11px] font-600 uppercase tracking-widest text-muted-foreground whitespace-nowrap">Expense Type</th>
              <th className="text-right px-4 py-3 text-[11px] font-600 uppercase tracking-widest text-muted-foreground whitespace-nowrap">Amount (TZS)</th>
              <th className="text-center px-4 py-3 text-[11px] font-600 uppercase tracking-widest text-muted-foreground whitespace-nowrap">Files</th>
              <th className="text-left px-4 py-3 text-[11px] font-600 uppercase tracking-widest text-muted-foreground whitespace-nowrap">Status</th>
            </tr>
          </thead>
          <tbody>
            {recent?.map((req, idx) => (
              <tr
                key={req?.id}
                className={`border-b border-border last:border-0 hover:bg-muted/40 transition-colors duration-100 ${
                  idx % 2 === 1 ? 'bg-muted/20' : ''
                }`}
              >
                <td className="px-4 py-3 font-500 text-primary tabular-nums text-xs whitespace-nowrap">
                  {req?.requestId}
                </td>
                <td className="px-4 py-3 text-foreground whitespace-nowrap">
                  {req?.requestorFirstName} {req?.requestorLastName}
                </td>
                <td className="px-4 py-3 text-foreground max-w-[180px] truncate">
                  {req?.customerProject}
                </td>
                <td className="px-4 py-3 text-muted-foreground whitespace-nowrap">
                  {req?.expenseType}
                </td>
                <td className="px-4 py-3 text-right font-600 tabular-nums text-foreground whitespace-nowrap">
                  {formatTZS(req?.amountRequested)}
                </td>
                <td className="px-4 py-3 text-center">
                  {req?.attachmentCount > 0 ? (
                    <span className="inline-flex items-center gap-1 text-xs text-muted-foreground">
                      <Paperclip size={12} />
                      {req?.attachmentCount}
                    </span>
                  ) : (
                    <span className="text-xs text-muted-foreground/40">—</span>
                  )}
                </td>
                <td className="px-4 py-3">
                  <StatusBadge status={req?.status} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}